import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  JsonDialogData,
  JsonViewerDialogComponent,
} from '../json-viewer-dialog/json-viewer-dialog.component';

@Injectable({
  providedIn: 'root', // Esto hace que el servicio esté disponible en toda la app.
})
export class JsonDialogService {
  private dialog = inject(MatDialog);

  /**
   * Abre un diálogo modal para mostrar un objeto JSON.
   * @param jsonData El objeto o array que se quiere visualizar.
   * @param title (Opcional) Un título para la ventana del diálogo.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public open(jsonData: any, title: string = 'Visor de JSON'): void {
    const dialogData: JsonDialogData = {
      jsonData,
      title,
    };

    this.dialog.open(JsonViewerDialogComponent, {
      data: dialogData,
      width: '800px',
      maxWidth: '95vw',
    });
  }
}
